import { Grid } from '@mui/material'
import { capitalizza, formattaDataEOra, ICONE, BaseGridLayout, BaseScatola } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import ConfigManager from 'components/config/ConfigManager'
import ScatolettaRiepilogo from 'components/ui/ScatolettaRiepilogo'
import ScatolettaDownloadAllegato from 'components/ui/ScatolettaDownloadAllegato'
import Sezione from 'components/ui/Sezione'
import Sottotitolo from 'components/ui/Sottotitolo'
import Testo from 'components/ui/Testo'
import Titoletto from 'components/ui/Titoletto'
import { Pagamento } from './SceltaPagamento'
import BadgeStatoPagamento from 'components/ui/frontoffice/BadgeStatoPagamento'
import { FRONTOFFICE_VERBALE_RIEPILOGO } from 'configuration/frontoffice'

const CFG = FRONTOFFICE_VERBALE_RIEPILOGO

export default function Riepilogo(props) {
  const { chiaveVerbale, verbale, pagamento, pagamentoPagato } = props
  const {
    numero_verbale,
    infrazione_data,
    contestazione_data,
    articoli,
    punti,
    intestatario,
    veicolo,
    procedura,
    files,
  } = verbale

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_VERBALE_RIEPILOGO]}
      render={({ txt }) =>
        <BaseGridLayout vertical spacing={3} noWrap>
          <>
            <Titoletto>{txt(pagamento ? CFG.TITOLO_CON_PAGAMENTO : CFG.TITOLO)}</Titoletto>
            <Testo noMargine>{txt(pagamento ? CFG.SOTTOTITOLO_CON_PAGAMENTO : CFG.SOTTOTITOLO)}</Testo>
            <BadgeStatoPagamento verbale={verbale} />
          </>
          {/* MODALITÀ DI PAGAMENTO SCELTA */}
          {pagamento &&
            <Sezione titolo={txt(CFG.SEZIONI_MODALITA_PAGAMENTO)}>
              <BaseScatola outlined>
                <Pagamento pagamento={pagamento} />
              </BaseScatola>
            </Sezione>
          }
          {/* DATI DEL VERBALE */}
          <Sezione titolo={txt(CFG.SEZIONI_DATI_VERBALE)}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.DESCRIZIONE} titolo={txt(CFG.SEZIONI_NUMERO_VERBALE)}>
                  <Testo grassetto>{capitalizza(procedura)} {numero_verbale}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.CALENDARIO_EVENTO} titolo={txt(CFG.SEZIONI_DATA_INFRAZIONE)}>
                  <Testo grassetto>{formattaDataEOra(infrazione_data)}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.NOTIFICA_IMPORTANTE} titolo={txt(CFG.SEZIONI_DATA_CONTESTAZIONE)}>
                  <Testo grassetto>{formattaDataEOra(contestazione_data)}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.MARTELLETTO} titolo={txt(CFG.SEZIONI_NORMATIVA)}>
                  <Testo grassetto>{txt(CFG.SEZIONI_NORMATIVA_VIOLAZIONE)} {articoli}</Testo>
                  <Testo grassetto>{txt(CFG.SEZIONI_NORMATIVA_PUNTI)} {punti}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.PERSONA} titolo={txt(CFG.SEZIONI_INTESTATARIO)}>
                  <Testo grassetto>{intestatario}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.VEICOLO} titolo={txt(CFG.SEZIONI_VEICOLO)}>
                  <Testo grassetto>{veicolo}</Testo>
                </ScatolettaRiepilogo>
              </Grid>
            </Grid>
          </Sezione>

          {/* DOCUMENTI SCARICABILI */}
          <Sezione
            titolo={txt(CFG.SEZIONI_DOCUMENTI_SCARICABILI)}
            sottotitolo={txt(CFG.SEZIONI_DOCUMENTI_SCARICABILI_SOTTOTITOLO)}
          >
            <Grid container spacing={2}>
              {files.map(file =>
                <Grid item xs={12} md={4} key={file.id}>
                  <ScatolettaDownloadAllegato
                    allegato={file}
                    chiavePerUuid={chiaveVerbale}
                  />
                </Grid>
              )}
            </Grid>
          </Sezione>



          {pagamento &&
            <Sottotitolo>{txt(CFG.ULTERIORI_INFO)}</Sottotitolo>
          }
          
          {/* PAGAMENTO PAGATO */}
          {pagamentoPagato &&
            <Sezione titolo={txt(CFG.SEZIONI_PAGAMENTO)}>
              <BaseScatola outlined>
                <Pagamento pagamento={pagamentoPagato} />
              </BaseScatola>
            </Sezione>
          }
        </BaseGridLayout>
      }
    />
  )
}
